// extracted by mini-css-extract-plugin
export var dropdownContainer = "_4x-5";
export var imageContainer = "_4x-4";
export var metricsGrid = "_4x-2";
export var productDetailContainer = "_4x-1";
export var productListContainer = "_4x-0";
export var subscriberTableContainer = "_4x-3";